import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center py-20 px-4 sm:px-6 lg:px-8 bg-[#FAF7F2] overflow-hidden" data-id="element-88">
      <div className="max-w-5xl mx-auto w-full grid md:grid-cols-2 gap-12 items-center" data-id="element-89">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 md:order-1" data-id="element-90">
          <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wide text-[#4A4238] bg-[#E8E0D5] rounded-full" data-id="element-91">
            For Postpartum Moms (0-6 Months)
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-[#4A4238] leading-[1.15] mb-6 text-balance" data-id="element-92">
            Stop "catching up." <br data-id="element-93" />
            <span className="italic text-[#7BA99E]" data-id="element-94">Start resetting.</span>
          </h1>

          <p className="text-xl md:text-2xl text-[#8C7E6E] font-serif italic mb-8" data-id="element-95">
            A 2–12 minute reset for postpartum chaos.
          </p>

          <div className="prose prose-lg text-[#4A4238] mb-10 leading-relaxed" data-id="element-96">
            <p className="mb-4" data-id="element-97">
              You don't need another list of "things to try." You've tried.
            </p>
            <p className="mb-4" data-id="element-98">
              And the worst part is… the tips aren't even bad. They just assume
              you have long time blocks, a stable schedule, and a nervous system
              that isn't running on fumes.
            </p>
            <p className="font-medium" data-id="element-99">
              Postpartum life doesn't give you time. It gives you{' '}
              <em data-id="element-100">time shards</em>.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-101">
            <Button withArrow onClick={() => document.getElementById('comprar')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-102">
              Get the Reset
            </Button>
          </div>
          <p className="mt-4 text-sm text-[#8C7E6E]" data-id="element-103">
            Instant download. Read in 15 mins.
          </p>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="order-1 md:order-2 relative" data-id="element-104">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl rotate-1 hover:rotate-0 transition-transform duration-700 ease-out" data-id="element-105">
            <div className="absolute inset-0 bg-[#4A4238]/5 pointer-events-none mix-blend-multiply" data-id="element-106"></div>
            <img src="https://cdn.magicpatterns.com/uploads/3E1kjCz7QvpQD5PR5TzZrA/image_1.png" alt="The 14-Day Calm Home Reset ebook displayed on a phone in a cozy, neutral setting with coffee and baby items" className="w-full h-auto object-cover" data-id="element-107" />
          </div>
          {/* Decorative elements */}
          <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-[#E8E0D5] rounded-full blur-3xl opacity-60" data-id="element-108"></div>
          <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-[#7BA99E] rounded-full blur-3xl opacity-20" data-id="element-109"></div>
        </motion.div>
      </div>
    </section>;
}